import styled from 'styled-components'

export const PlainTextarea = styled.textarea`
    width: 100%;
`
